/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { defaultState, ChangesState } from './default.state'
import * as FilterActions from '@src/redux/actions/filter.actions'
import * as Changes from '@src/redux/actions/changes.actions'

export type ChangesActionTypes = Changes.ActionTypes | FilterActions.ActionTypes

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): ChangesState {
  switch (action.type) {
    case ActionTypes.Changes.GET_CHANGES_LIST_SUCCESS: {
      const { data, isPending } = action?.payload
      const {
        changes,
        counts,
        pages_count,
        high_count,
        medium_count,
        low_count,
        total_count
      } = data || {}
      return {
        ...state,
        changesList: changes,
        counts,
        pagesCount: pages_count,
        highCount: high_count,
        mediumCount: medium_count,
        lowCount: low_count,
        totalCount: total_count,
        isPending
      }
    }

    case ActionTypes.Changes.GET_CHANGES_LIST_FAIL: {
      return {
        ...state,
        error: action.payload.error
      }
    }

    case ActionTypes.Changes.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    case ActionTypes.Changes.DISPOSE_CHANGES: {
      return {
        ...state,
        changesList: []
      }
    }

    case ActionTypes.Changes.SET_TAB: {
      return {
        ...state,
        selectedType: action.payload.tab
      }
    }
    case ActionTypes.Filter.APPLY_NOW:
    case ActionTypes.Filter.RESET_ALL: {
      return {
        ...state,
        selectedType: defaultState.selectedType
      }
    }
    case ActionTypes.Changes.SET_USE_CHANGES_PAGE_FLAG: {
      return {
        ...state,
        useChangesPage: action.payload
      }
    }

    default: {
      return state
    }
  }
}
